export default __webpack_public_path__ + "static/media/title_shapes.66d7b59c.svg";